export default "__VITE_ASSET__C$1S4k0Z__"